export default {
  display: 'flex',
  alignItems: 'center',
};
